import React, { Component } from 'react';
import Loader from '../../components/UI/loader';
import RandomCharView from '../../components/randomCharView';
import ErrorMessage from '../../components/errorMessage';
import { generateAPI_Id } from '../../helpers';
import { CHARACTERS } from '../../utils/constants';
import withGoTService from '../../hoc/withGoTService';
import { object } from 'prop-types';

class RandomChar extends Component {
  static propTypes = {
    gotService: object,
  }

  state = {
    char: {},
    loading: true,
    error: false,
    showRandomChar: true,
    _isMounted: false,
  }

  componentDidMount() {
    this._isMounted = true

    if (this._isMounted) {
      this.updateChar()
      this.timerId = setInterval(this.updateChar, 1500)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    clearInterval(this.timerId)
  }

  onError = () => {
    this.setState({
      error: true,
      loading: false
    })
  }

  onLoaded = data => {
    this.setState({ char: data, loading: false })
  }

  updateChar = () => {
    const { gotService } = this.props
    //First 25 char-s are missing a lot of data in API
    const id = generateAPI_Id(140, 25) //getting chars from 25-140

    gotService.getItem(CHARACTERS, id)
      .then(char => {
        if (this._isMounted) {
          this.onLoaded.bind(null, char)()
        }
      })
      .catch(this.onError)
  }

  render() {
    const { char, loading, error } = this.state

    const errorMessage = error && <ErrorMessage />
    const loader = loading && <Loader />
    const content = !(loading || error) && <RandomCharView {...char} />

    return (
      <div className="random-block rounded">
        {errorMessage}
        {loader}
        {content}
      </div>
    )
  }
}

export default withGoTService()(RandomChar)